import { queryDocuments, getDocumentById } from "../firebase/firestore";

export const rankingService = {
    async calculateUserScore(userId) {
        const user = await getDocumentById("users", userId);
        const progresses = await queryDocuments("studentProgress", [["userId", "==", userId]]);

        const totalCredits = user?.totalCredits || 0;
        const totalLevelsCleared = progresses.reduce(
            (sum, p) => sum + Object.values(p.levelStatus || {}).filter((s) => s.cleared).length,
            0
        );
        const completedPaths = progresses.filter((p) => p.pathCompleted).length;

        const score = (totalCredits * 1) + (totalLevelsCleared * 5) + (completedPaths * 50);

        return {
            userId,
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            collegeName: user?.collegeName,
            totalCredits,
            totalLevelsCleared,
            completedPaths,
            score
        };
    },

    async getGlobalRanking(limit = 100) {
        const allUsers = await queryDocuments("users", [["role", "==", "student"]]);

        const rankings = await Promise.all(
            allUsers.map((user) => this.calculateUserScore(user.id))
        );

        return rankings
            .sort((a, b) => b.score - a.score)
            .slice(0, limit)
            .map((item, index) => ({
                ...item,
                rank: index + 1
            }));
    },

    async getRankingByCollege(collegeName, limit = 100) {
        const collegeUsers = await queryDocuments("users", [
            ["role", "==", "student"],
            ["collegeName", "==", collegeName]
        ]);

        const rankings = await Promise.all(
            collegeUsers.map((user) => this.calculateUserScore(user.id))
        );

        return rankings
            .sort((a, b) => b.score - a.score)
            .slice(0, limit)
            .map((item, index) => ({
                ...item,
                rank: index + 1
            }));
    },

    async getUserRank(userId) {
        const globalRanking = await this.getGlobalRanking(1000);
        const userRankData = globalRanking.find((r) => r.userId === userId);

        if (!userRankData) {
            return null;
        }

        return {
            ...userRankData,
            totalStudents: globalRanking.length,
            percentile: ((globalRanking.length - userRankData.rank) / globalRanking.length) * 100
        };
    },

    async getUserRankInCollege(userId, collegeName) {
        const collegeRanking = await this.getRankingByCollege(collegeName, 1000);
        const userRankData = collegeRanking.find((r) => r.userId === userId);

        if (!userRankData) {
            return null;
        }

        return {
            ...userRankData,
            totalInCollege: collegeRanking.length,
            percentile: ((collegeRanking.length - userRankData.rank) / collegeRanking.length) * 100
        };
    },

    async getStartupRanking(limit = 50) {
        const allStartups = await queryDocuments("startups", [["status", "==", "active"]]);

        const startupRankings = allStartups.map((startup, index) => ({
            id: startup.id,
            name: startup.name,
            foundedBy: startup.foundedBy,
            stage: startup.stage,
            score: startup.score || 0,
            rank: index + 1
        }));

        return startupRankings.sort((a, b) => b.score - a.score);
    }
};

export default rankingService;
